export default __webpack_public_path__ + "static/media/el_1.c81a8541.mp3";